$(function () {
  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll(".navbar-burger"), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {
    // Add a click event on each of them
    $navbarBurgers.forEach((el) => {
      el.addEventListener("click", () => {
        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle("is-active");
        $target.classList.toggle("is-active");
        document.getElementById("navMenuSide").classList.toggle("is-active")

      });
    });
  }
});
//Toggle closing sidebar, burger button and navside.
$(function () {
  if(document.getElementById('main-nav')){
    document.getElementById('btn-close-side').addEventListener("click", () => {
      document.getElementById("navMenu").classList.toggle("is-active");
      document.getElementById("navMenuSide").classList.toggle("is-active");
      document.getElementById("navbar--burger").classList.toggle("is-active");
    });
    document.getElementById('navMenu').addEventListener("click", () => {
      document.getElementById("navMenu").classList.toggle("is-active");
      document.getElementById("navMenuSide").classList.toggle("is-active");
      document.getElementById("navbar--burger").classList.toggle("is-active");
      
    });
  }  
});
//Toggle dropdown activation, and removes activation when touching other elements.
$(function () {
  if(document.getElementById('main-nav')){
    const $navbarDropDowns = Array.prototype.slice.call(document.querySelectorAll(".is-dropdown"), 0);
    if ($navbarDropDowns.length > 0) {
      $navbarDropDowns.forEach((el) => {
        el.addEventListener("click", () => {
          el.classList.toggle("is-active");
        });
      });
    }
    document.addEventListener("click", function(event) {
      if(!$(event.target).closest('#firstDropdown').length){
        firstDropdown.classList.remove("is-active");
      }
      if(!$(event.target).closest('#secondDropdown').length){
        secondDropdown.classList.remove("is-active");
      }
      
    });
  }
});

// ***************************
  // Nav events
  // ***************************

  //Nav dropdowns
  (function initDropdownEvents() {
    var timeout;
    $('.dropdown-btn').on('mouseenter', function() {
      const targetMenu = $(this).data('menu');
      clearTimeout(timeout);
      $('.dropdown-menu').not(targetMenu).removeClass('is-active');
      $(targetMenu).addClass('is-active');
    }).on('mouseleave', function() {
      const targetMenu = $(this).data('menu');
      timeout = setTimeout(function() {
        $(targetMenu).removeClass('is-active');
      }, 300);
    });
    $('.dropdown-menu').on('mouseenter', function() {
      clearTimeout(timeout);
    }).on('mouseleave', function() {
      const targetMenu = $(this).attr('id');
      timeout = setTimeout(function() {
        $('#' + targetMenu).removeClass('is-active');
      }, 300);
    });
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.dropdown-menu').length && !$(e.target).closest('.dropdown-btn').length) {
        $('.dropdown-menu').removeClass('is-active');
      }
    });
    const menuContainer = document.getElementById("top-nav");
    if(menuContainer) {
      $(document).on('click', function (e) {
        $('.dropdown-menu').removeClass('is-active');
      });
    }
  })();

  //Sidenav menu
  (function initSideMenuEvents() {
      const mainTitle = document.querySelector('.section-text');
      const mainItems = Array.from(document.querySelectorAll('.main-item'));
      const lists = Array.from(document.querySelectorAll('.child-item'));
      const backBtn = document.querySelector('.back-btn');
      const mainList = document.querySelector('.main-list');

      mainItems.forEach(function(mainItem, index) {
          const mainItemText = mainItem.querySelector('span');

          mainItem.addEventListener('click', function() {
              lists.forEach(function(list) {
                  list.classList.add('is-hidden');
              });
              const list = lists[index];
              if (list) {
                  list.classList.remove('is-hidden');
              }
              mainTitle.textContent = mainItemText.textContent;
              backBtn.classList.remove("is-hidden");
              mainList.classList.add('is-hidden');
          });
      });

      backBtn.addEventListener('click', function() {
          mainTitle.textContent = '';
          mainList.classList.remove('is-hidden');
          lists.forEach(function(list) {
              list.classList.add('is-hidden');
          });
          backBtn.classList.add("is-hidden");
      });
  })();

  //Hamburger menu

  (function initHamburgerMenu() {
    const $container = $('.side-menu');
    $container.on('click', function (e) {
      e.stopPropagation();
    });
    $('.js-hamburger-btn').on('click', function (e) {
      $container.toggleClass('is-active');
      e.stopPropagation();
    });
    $('.side-close-btn').on('click', function () {
      $container.toggleClass('is-active');
    });
    const menuContainer = document.getElementById("side-menu");
    if(menuContainer) {
      $(document).on('click', function () {
        $('.side-menu').removeClass('is-active');
      }); 
    }    
  })();

// Start of Expandable Sections
const expandableElements = $('.data-table');
for (let i = 0; i < expandableElements.length; i++) {
  $(expandableElements[i]).on('click', () => {
    $(expandableElements[i]).toggleClass('data-table--noborder');
    $(expandableElements[i]).find('.data-table-simple').toggleClass('data-table-simple__expanded');
    $(expandableElements[i]).find('.more').toggleClass('is-hidden');
    $(expandableElements[i]).find('.less').toggleClass('is-hidden');
    $(expandableElements[i]).find('.orange-check').toggleClass('is-hidden');
    $(expandableElements[i]).find('.white-check').toggleClass('is-hidden');
    $(expandableElements[i]).find('.expand').toggleClass('show');
  });
}
//Progress bar
const table = $('.details-table');
const progressBar = $('.progress-bar');
for (let i = 0; i < table.length; i++) {
  table[i].addEventListener('scroll', () => {
    let width = table[i].clientWidth;
    let scrollWidth = table[i].scrollWidth - width;
    let scrollLeft = table[i].scrollLeft;
    let percent = Math.floor(scrollLeft / scrollWidth * 100);
    progressBar[i].style.width = percent + "%";
  });
}
//End of Expandable Sections

//Start of Related Vins
const relatedVinsTable = document.getElementById("related-vins-scroll");
if (relatedVinsTable) {
  relatedVinsTable.addEventListener('scroll', e => {
    const scrolled = (relatedVinsTable.scrollLeft / (relatedVinsTable.scrollWidth - relatedVinsTable.clientWidth)) * 100;
    document.getElementById("progress-bar").style.width = scrolled + "%";
  });
}
//End of Related Vins

//Updating backgound images on car images slides that have errors.
$(function () {
  // Get all "car-img" elements
  const $carImageSlides = Array.prototype.slice.call(
    document.querySelectorAll(".car-slide"),
    0
  );

  // Check if there are any slides
  if ($carImageSlides.length > 0) {
    // Add error event listener
    $carImageSlides.forEach((el) => {
      el.addEventListener("error", () => {
        el.parentNode.style.backgroundImage = "url('" + el.src + "')";
      });
    });
  }
});

$(function () {
  // Get all "car-img" elements
  const $carImages = Array.prototype.slice.call(
    document.querySelectorAll(".card--car"),
    0
  );

  // Check if there are any slides
  $carImages.forEach((element) => {
    let img = element.querySelector('.car-img');
    let heading = element.querySelector('.card-heading').innerText;
    img.setAttribute("alt", heading);
  });
});
